<template>
    <div>
        <div class="temporary-locker-search flex items-center justify-between">
            <div class="flex items-center">
                <el-select
                    class="pr-2"
                    v-model="form.storeId"
                    :placeholder="$t('Common.all_store2')">
                    <el-option
                        v-for="item in stores"
                        :key="item.id"
                        :label="item.name"
                        :value="Number(item.id)">
                    </el-option>
                </el-select>
                <el-select
                    class="pr-2"
                    v-model="form.type"
                    :placeholder="$t('Setting.allnews')">
                    <el-option
                        v-for="item in options"
                        :key="item.id"
                        :label="item.name"
                        :value="Number(item.id)">
                    </el-option>
                </el-select>
                <div class="pl-2">
                    <el-button type="primary" @click="fetchData(1)">
                        {{ $t('Common.search') }}
                    </el-button>
                    <el-button @click="resetForm">{{ $t('Common.clear') }}</el-button>
                </div>
            </div>
            <el-button type="primary" @click="handleRead">
                {{ $t('Setting.readed') }}
            </el-button>
        </div>

        <el-table
            :data="tableData"
            ref="tableData"
            border
            :row-class-name="tableRowClassName"
            @row-click="clickRow"
            @selection-change="handleSelectionChange"
            style="width: 100%; margin-top: 20px">
            <el-table-column type="selection" width="90" />
            <el-table-column prop="createdAt" width="120" :label="$t('Common.time')" />
            <el-table-column prop="type" width="61" :label="$t('Sell.TicketPrint.type')" />
            <el-table-column prop="content" :label="$t('Setting.content')" />
        </el-table>

        <el-pagination
            v-if="tableData && tableData.length"
            class="text-right mt-10"
            @current-change="fetchData"
            :current-page.sync="form.page"
            :page-size="form.size"
            layout="total, prev, pager, next, jumper"
            :total="pagination.total"
        ></el-pagination>
    </div>
</template>

<script>

export default {
    components: {},
    data() {
        return {
            tableData: [],
            messages: [],
            form: {
                storeId: null,
                type: null,
                page: 1,
                size: 50,
            },
            pagination: {
                total: 0,
            },
            stores: [],
            options: [
                {
                    id: 1,
                    name: this.$t('Course.pay'),
                }, {
                    id: 2,
                    name: this.$t('Setting.system'),
                }, {
                    id: 3,
                    name: this.$t('Setting.system'),
                }, {
                    id: 4,
                    name: this.$t('Common.sign'),
                }, {
                    id: 5,
                    name: this.$t('Common.cancel'),
                },
            ],
        };
    },
    created() {
        this.fetchData();
        this.fetchStore();
    },
    methods: {
        resetForm() {
            this.form = {
                storeId: null,
                type: null,
                page: 1,
                size: 50,
            };
        },
        fetchData(page = null) {
            if (page) this.form.page = page;
            API.get('message', {
                params: this.form,
            }).then(res => {
                this.tableData = res.content;
                this.pagination.total = res.totalElements;
            });
        },
        fetchStore() {
            API.get('store/list').then(res => {
                this.stores = res;
            });
        },
        handleSelectionChange(val) {
            this.messages = val;
        },
        clickRow(row) {
            this.$refs.tableData.toggleRowSelection(row);
        },
        tableRowClassName({row, rowIndex}) {
            if (row.unread) return 'fitness-info-row';
            else return '';
        },
        handleRead() {
            if (this.messages && !this.messages.length) return $ele.$message.warning(this.$t('Message.selecenews'));
            API.put('message/read', {
                messageIds: this.messages.map(el => el.id),
            }).then(() => {
                $ele.$message.success(this.$t('Message.success'));
                this.fetchData();
                this.fetchCount();
            });
        },
        fetchCount() {
            API.get('message/unread-count').then(res => {
                this.$store.commit('setCount', res.unreadCount);
            });
        },
    },
};
</script>
